import React from 'react';
import "../assets/css/styles.table.css"
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Layout from './Layout';
import {useListPOEngHook} from '../hook/ListPOEngHook'
import GridNumberPaging from '../components/GridNumberPaging';
import Bindcomponent from '../utils/bindcomponent';
const ListPOEng = () => {
  const {message,setmessage,tipe,settipe,columns,rows,filterModel,setFilterModel,columnVisibilityModel,setColumnVisibilityModel} = useListPOEngHook()
 
  return (
    <>
      <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
      <div className='pd'><b> Project List</b></div>
      <div className="pd">
      <Box>
      
       <Box sx={{ height: "100%" }}>
         <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"listpogrid"} rowid={"id"} columvisibility={{id :false, id_project:false,assigned_by:false,updated_by:false}}></Bindcomponent>  
       {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"listpogrid"} rowid={"id"} columvisibility={{id :false, id_project:false,assigned_by:false,updated_by:false}}></GridNumberPaging>   */}
        {/* <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          disableColumnSelector
          disableColumnFilter
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          wrap={true}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowId={(row) => row.id}
        /> */}
      </Box>
    </Box>
    </div>
  </Layout>

    </>
  );
};

export default ListPOEng;